module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "freights-tracking"
    }
  }, [_c('div', {
    staticClass: "md-layout-row heading"
  }, [(_vm.title) ? _c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s((_vm.freight.traking_number) ? _vm.title + ' ' + _vm.freight.traking_number : _vm.title))]) : _vm._e()]), _c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-content', {
    staticClass: "freight-description"
  }), _c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.trackingAmount
    },
    on: {
      "refresh": _vm.getFreightTracking
    },
    scopedSlots: _vm._u([{
      key: "stock.name",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.stock.name))]
      }
    }, {
      key: "responsible.login",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.item.responsible.login))]
      }
    }]),
    model: {
      value: (_vm.tracking),
      callback: function($$v) {
        _vm.tracking = $$v
      },
      expression: "tracking"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d9873e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/FreightTracking.vue
// module id = 1166
// module chunks = 0